<template>
  <section>
    <!-- "header" content -->
    <header-content-home :topSpace="busTopSpace" />

    <!-- second frame (purple x video) -->
    <second-frame />

    <!-- third frame (yellow x photo (onix)) -->
    <third-frame />

    <!-- step by step -->
    <step-by-step />

    <!-- depoiments -->
    <depoiments />

    <!-- press -->
    <!-- <press/> -->

    <!-- result counter -->
    <!-- <result-counter/> -->

    <!-- press -->
    <!-- <press /> -->

    <!-- insta -->
    <insta />

    <!-- auto brookers -->
    <auto-brookers />

    <!-- newsletter container -->
    <section class="w-100 bg-gd-purple px-3">
      <newsletter class="position-relative shadow-lg" style="top: -50px;" />
    </section>
  </section>
</template>

<script>
// home
import HeaderContentHome from "@/components/home/HeaderContentHome";
import SecondFrame from "@/components/home/SecondFrame";
import ThirdFrame from "@/components/home/ThirdFrame";
import StepByStep from "@/components/home/StepByStep";
import Depoiments from "@/components/home/Depoiments";
import Insta from "@/components/home/Instagram";
// import Counter from '@/components/home/Counter'
// import Press from '@/components/Press'
import AutoBrookers from "@/components/home/AutoBrookers";

// all
import Newsletter from "@/components/Newsletter";
import Press from "@/components/Press";

export default {
  props: {
    busTopSpace: {
      type: String,
      required: true,
    },
  },
  components: {
    "header-content-home": HeaderContentHome,
    "second-frame": SecondFrame,
    newsletter: Newsletter,
    "third-frame": ThirdFrame,
    "step-by-step": StepByStep,
    depoiments: Depoiments,
    insta: Insta,
    // press: Press,
    // 'result-counter': Counter,
    // 'press': Press,
    "auto-brookers": AutoBrookers,
  },
};
</script>
